import { render, staticRenderFns } from "./WebhookLogList.vue?vue&type=template&id=20bd7382"
import script from "./WebhookLogList.vue?vue&type=script&lang=js"
export * from "./WebhookLogList.vue?vue&type=script&lang=js"
import style0 from "./WebhookLogList.vue?vue&type=style&index=0&id=20bd7382&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports